import { Component, HostListener, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject, debounceTime } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { CartService } from 'src/app/services/cart.service';
import { Router, ActivatedRoute } from '@angular/router';
import { getCustomerToken } from 'src/app/shared/utils';
import { LoginPopupComponent } from 'src/app/modules/shop/login-popup/login-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { QuickCartComponent } from '../quick-cart/quick-cart.component';
export interface MenuItem {
  id: number;
  category_id: number;
  parent_id: number;
  name: string;
  slug: string;
  children?: MenuItem[];
}
@Component({
  selector: 'app-shop-header',
  templateUrl: './shop-header.component.html',
  styleUrls: ['./shop-header.component.scss']
})
export class ShopHeaderComponent {
  private searchInput$: Subject<string> = new Subject();
  baseUrl = environment.BASE_URL;
  shopBaseUrl = environment.SHOP_BASE_URL;
  shopBaseUrl2 = environment.SHOP_BASE_URL2
  isScroll: boolean = false;
  searchText: string = '';
  productList: any[] = [];
  showNoData: boolean = false;
  countCartItems: number = 0;
  isQuickCart: boolean = false;
  cartItems: any;
  categories: any[] = [];
  categoriesList: any[] = [];

  currentMenu !: number;
  selectedCategory: any[] = [];
  isShowMenu: boolean = false;
  activeCategoryId: number | string | null = null;
  portalUrl: string = environment.PORTAL_URL;
  tokenItem: boolean = false;
  rightPanelClick: boolean = false;
  rightPanelActive: boolean = false;
  isMobile: boolean = window.innerWidth <= 768;
  collapsedState: Map<any, boolean> = new Map();
  activeListItem!: any;
  sidebarList: any[] = [];
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.isMobile = window.innerWidth <= 768;
  }
  @Input() megaMenu: boolean = true;
  nameInitials: string = '';
  userEmail: any;
  profileName: string = '';
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false })
  chatContainer!: ViewContainerRef;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private cartService: CartService,
    private dialog: MatDialog,
  ) { }
  ngOnInit() {
    this.commonService.customerTokenFound.subscribe(() => {
      this.tokenItem = getCustomerToken();
      if (this.tokenItem) {
        this.checkAccesstoken();
      }
    });
    this.setupSearchDebouncer();
    this.cartCounter();
    this.cartService.cartItems;
    //this.cartService.getCartItems();
    this.getCategories();
    this.checkAccesstoken();
    this.route.queryParams.subscribe((params) => {
      let catId = params['catId'];
      if (catId) {
        this.setActive(catId);
      }
    });
  }
  getCategories() {
    let apiUrl = `${this.shopBaseUrl}categories?page=1&limit=1000`;
    this.commonService.getData(apiUrl).subscribe((data) => {
      this.categories = data?.data;
      this.buildMenuTree(this.categories);
      this.buildSidebarMenu(this.categories);
    });
  }
  buildMenuTree(items: MenuItem[], parentId: number | null = 1): MenuItem[] {
    this.categoriesList = items
      .filter((item) => item.parent_id === parentId)
      .map((item) => ({
        ...item,
        //isColapsed: true,
        children: this.buildMenuTree(items, item.category_id),
      }));
    return this.categoriesList;
  }
  openMegaMenu(menuList: any, menuIndex: number, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.currentMenu = menuIndex;
    if (menuList === this.selectedCategory) {
      this.selectedCategory = [];
      this.isShowMenu = false;
    } else {
      this.isShowMenu = true;
      this.selectedCategory = menuList;
    }
  }
  @HostListener('window:scroll', [])
  onScroll(): void {
    window.scrollY > 50 ? this.isScroll = true : this.isScroll = false;
  }
  setupSearchDebouncer() {
    this.searchInput$.pipe(debounceTime(1000)).subscribe((term: string) => {
      this.searchText = term;
      this.getProductData();
    });
  }
  searchByProduct(event: any) {
    if (event.target.value.trim().split('').length >= 2) {
      this.searchText = event.target.value;
      this.searchInput$.next(this.searchText);
    }
    //this.getProductData(this.searchText);
  }
  getProductData() {
    this.commonService
      .getData(`${this.shopBaseUrl}products?name=${this.searchText}`)
      .subscribe((res) => {
        this.productList = res?.data;
        this.showNoData = true;
      });
  }
  onProductSelected(event: any, itemId: number) {
    //let productId = last(event.option.value);
    if (event.isUserInput && itemId) {
      let productId = itemId;
      this.router.navigate(['/product', productId], { skipLocationChange: false });
      //this.cartService.updateProductId(productId);
    }
  }
  nevigateCheckout() {
    let customerToken = getCustomerToken();
    if (customerToken) {
      this.router.navigateByUrl('/checkout');
      //this.router.navigate(['/checkout']);
      this.isQuickCart = false;
    } else {
      ///this.isQuickCart = false;
      ///this.router.navigateByUrl('/prelogin')
      //this.openLoginPopup();
      document.body.classList.add('overflow');
      this.quickCart();
      const chatCompRef = this.chatContainer.createComponent(QuickCartComponent);
      const rfqDetails = chatCompRef.instance;
      chatCompRef.instance.close = () => {
        this.chatContainer.clear();
        document.body.classList.remove('overflow');
      };
    }
  }
  checkAccesstoken() {
    let customerToken = getCustomerToken();
    if (customerToken) {
      this.tokenItem = customerToken;
      this.cartService.getCartItems();
      //this.cartCounter();
      this.setDisplayName();
    } else {
      let cartLocalData: any = sessionStorage.getItem('cartData');
      if (cartLocalData) {
        let dataItem = JSON.parse(cartLocalData);
        let map: any = new Map(Object.entries(dataItem));
        this.countCartItems = map.size;
      }
    }
  }
  cartCounter() {
    this.cartService.cartUpdates$.subscribe({
      next: (data) => {
        this.countCartItems = data?.response?.length;
      },
    });

    this.commonService.shopPopupLogin$.subscribe({
      next: (data: boolean) => {
        if (data) {
          this.openLoginPopup();
        }
      },
    });

    this.commonService.sharedData$.subscribe({
      next: (data: any) => {
        if (data == 'logout') {
          // this.cartService.getCartItems();
          this.countCartItems = 0;
        }
      },
    });
  }
  openLoginPopup(): void {
    const isSmallScreen = window.innerWidth <= 767;
    this.dialog
      .open(LoginPopupComponent, {
        width: '400px',
        //panelClass: 'custom-modalbox-500',
        panelClass: isSmallScreen
          ? 'custom-modalbox-500-responsive'
          : 'custom-modalbox-500',
        // position: { right: isSmallScreen ? '10%' : '30%' },
        //position: { right: '30%' },
        data: { baseUrl: this.baseUrl },
      })
      .afterClosed()
      .subscribe({
        next: (isTrue: boolean) => {
          if (isTrue) {
          }
        },
      });
  }
  quickCart() {
    this.isQuickCart = !this.isQuickCart;
    let customerToken = getCustomerToken();
    if (customerToken) {
      let setCompanyId = sessionStorage.getItem('customercompanyId');
      let cartApi = `${this.baseUrl}rfq/cart/getCartItem?companyId=${setCompanyId}`;
      this.commonService.getData(cartApi).subscribe((data) => {
        this.cartItems = data?.response;
      });
    } else {
      let cartLocalData: any = sessionStorage.getItem('cartData');
      let dataItem = JSON.parse(cartLocalData);
      this.cartItems = dataItem != null ? Object.values(dataItem) : [];
      //this.cartItems = dataItem  Object.values(dataItem);
    }
  }
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    // Close the mega menu if the click is outside the menu bar
    if (!targetElement.closest('.megaMenu')) {
      this.isShowMenu = false;
      this.selectedCategory = [];
    }
  }
  getCategoryProduct(categoryId: number, categoryName: string, slug: string) {
    this.activeCategoryId = categoryId;
    this.router.navigate(['/products'], {
      queryParams: {
        catId: categoryId,
      },
    });
    if (this.isMobile) {
      this.rightPanelActive = !this.rightPanelActive;
      document.body.classList.remove('menuOpen');
    }
  }
  customerSignup() {
    this.router.navigate(['/user-register'])
    //this.router.navigate(['/registration']);
  }

  getChevronIcon(menuIndex: number, category: any): string {
    return menuIndex === this.currentMenu && category.children?.length && this.isShowMenu ? 'ChevronUp' : 'ChevronDown';
  }
  onRightPanelClick(event: any) {
    this.rightPanelClick = true;
    this.rightPanelActive = !this.rightPanelActive;
    event.preventDefault();
    document.body.classList.add('menuOpen');
  }
  onSidenavClose(event: any) {
    this.rightPanelActive = !this.rightPanelActive;
    document.body.classList.remove('menuOpen');
  }
  buildSidebarMenu(items: MenuItem[], parentId: number | null = 1): MenuItem[] {
    this.sidebarList = items
      .filter((item) => item.parent_id === parentId)
      .map((item) => ({
        ...item,
        //isColapsed: true,
        children: this.buildSidebarMenu(items, item.category_id),
      }));
    return this.sidebarList;
  }
  identify(index: number, item: any) {
    return item.id;
  }
  toggleCollapse(item: MenuItem): void {
    const isCollapsed = this.collapsedState.get(item.category_id) || false;
    this.collapsedState.set(item.category_id, !isCollapsed);
  }
  isCollapsed(item: MenuItem): boolean {
    return this.collapsedState.get(item.category_id) || false;
  }
  setActive(categoryId: any) {
    this.activeListItem = categoryId;
  }
  logOut() {
    const apiUrl = `${this.baseUrl}auth-service/logout`;
    const payload = {
      idToken: '',
      accessToken: sessionStorage.getItem('customerAccessToken'),
      refreshToken: sessionStorage.getItem('customerRefreshToken'),
    };
    this.commonService.postDatawithoutHeaders(apiUrl, payload).subscribe({
      next: (res: any) => {
        sessionStorage.clear();
        this.tokenItem = false;
        this.countCartItems = 0;
        this.router.navigateByUrl('/');
      }
    })
  }
  customerSignin() {
    window.open(`${this.portalUrl}`, '_blank');
  }
  setDisplayName() {
    let userId = sessionStorage.getItem('customeruserId');
    let apiUrl = `${this.baseUrl}customer/user-profile/getUserProfileCustomer?userId=${userId}`;
    this.commonService.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.userEmail = res.response.email ?? sessionStorage.getItem('adminemailId');
        sessionStorage.setItem('customerEmproCode', JSON.stringify(res.response?.emproCode || null));
        let { firstName, lastName } = res.response;
        this.commonService.setData(`${firstName} ${lastName}`);
        this.setNameInitials(firstName, lastName);
      }
    })
  }
  setNameInitials(firstName: string, lastName: string) {
    this.profileName = firstName + ' ' + lastName;
    firstName ??= '';
    lastName ??= '';

    const fullUserName = firstName?.split(' ') + ' ' + lastName?.split(' ');
    sessionStorage.setItem('customerUserName', fullUserName);
    this.nameInitials = fullUserName?.split(' ')
      .map((n) => n[0])
      .join('')
      ?.toUpperCase();
  }
  redirectDashboard() {
    this.router.navigate(['/dashboard']);
  }
}

